import * as React from 'react';
import invariant from 'invariant';
import { MenuContext } from "./MenuContext";
export var useMenuContext = function useMenuContext() {
  var context = React.useContext(MenuContext);
  invariant(context, 'Missing menu context. Make sure MenuProvider is present.');
  return context;
};